import {Alert, Button, Col, Container, GoBack, Icon, Modal, Row, Table} from "design-react-kit";
import React, {useEffect, useState} from "react";
import {properties} from "../../../config/properties";
import {useLocation, useNavigate} from "react-router-dom";
import Spinner from "../../layout/Spinner";


const styles = {

    sidebar: {
        backgroundColor: "#0b5ed7", // blu
        padding: "1rem",
        borderRadius: "8px",
        minWidth: "180px",
        color: "white",
        fontWeight: "600",
    },
    sidebarButton: {
        backgroundColor: "white",
        margin: "0.5rem 0",
        width: "100%",
    },
    card1: {
        padding: "2rem",
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        width: "100%",
        maxWidth: "600px",
    },
    card: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle: {
        padding: '2rem',
        borderRadius: 'none',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px #fefefe',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle1: {
        backgroundColor: "#0b5ed7",
        color: "white",
        padding: "1rem",
        borderRadius: "8px",
        marginBottom: "2rem",
        textAlign: "center",
        fontSize: "1.5rem",
        fontWeight: 600,
    },
    tableContainer: {
        resize: 'vertical',
        minHeight: '20vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)

        height: '90vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)
        maxHeight: 'max-content',
        overflowY: 'auto', // Mostra la scrollbar verticale solo se necessario
        // border: '1px solid #e0e0e0',  Bordo sottile per definire l'area di scroll

    },
    tableHeader: {
        borderBottom: '2px solid #dee2e6',
        backgroundColor: '#06c',
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '1.25rem',
        letterSpacing: '0.05em',
        // --- Proprietà per lo sticky header ---
        position: 'sticky',
        top: 0, // Si "attacca" al bordo superiore del contenitore di scroll
        zIndex: 1 // Assicura che l'header stia sopra il contenuto della tabella
    },
    tableRowText: {
        color: '#333',
        fontWeight: 500, // Regular/Medium per una migliore leggibilità
        fontSize: "1rem",
        verticalAlign: 'middle', // Allinea verticalmente il testo
        textAlign: "left"
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0.5rem'
    },
    fieldLabel: {
        fontWeight: '500',
        color: '#6c757d',
        marginBottom: '0.25rem',
        fontSize: '0.9rem',
    },
    fieldValue: {
        marginBottom: '1rem',
        fontWeight: '600',
        fontSize: '1rem',
        color: '#212529',
    },
};


const GestioneDeleghePersona = ({user}) => {

    const location = useLocation();
    const { idProfilo } = location.state || {};
    const {esito} = location.state || {};
    const {nomeProfilo} = location.state || {}
    const {cognomeProfilo} = location.state || {}
    const navigate = useNavigate();

    const initialLimit = 10;
    const initialOffset = 0;

    const [limit, setLimit] = useState(initialLimit);
    const [offset, setOffset] = useState(initialOffset);

    const [deleghe, setDeleghe] = useState([]);
    const [delegaToDelete, setDelegaToDelete] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });

    const [loadingUser, setLoadingUser] = useState(true);



    const getDelegheList = async (params) => {

        try {


            setLoadingUser(true);

            const res = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/getDeleghePersona",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(params),
                }
            );

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");

            const data = await res.json();
            setDeleghe(data.datiDeleghe);

        } catch (e) {
            setDeleghe([]);
            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.'});
            window.scrollTo({top: 0, behavior: 'smooth'});
        }finally {
            setLoadingUser(false);
        }
    };

    const openDeleteConfirm = (delega) => {
        setDelegaToDelete(delega);
        setShowConfirmModal(true);
    };

    const closeDeleteConfirm = () => {
        setDelegaToDelete(null);
        setShowConfirmModal(false);
    };

    const confirmDelete = async () => {
        if (!delegaToDelete) return;

        try {

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/delete/delegaPersona`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: delegaToDelete.idPersonaDelega, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),
            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }


            const json = await res.json();

            if (json.esito === "OK") {
                setAlert({ visible: true, type: 'success', message: json.messaggio });
                await getDelegheList({idProfilo : idProfilo, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente});
            } else {
                setAlert({ visible: true, type: 'danger', message: json.messaggio});
            }
        } catch (e) {
            setAlert({ visible: true, type: 'danger', message: 'Errore di comunicazione con il server.' });
        } finally {
            closeDeleteConfirm();
        }
    };

    async function goToInserimentoDelega(){


        navigate('/private/inserimentoDeleghePersona', { state: { idProfilo : idProfilo , nomeProfilo : nomeProfilo , cognomeProfilo : cognomeProfilo} });
    }


    async function goToEditDelega(delega){


        navigate('/private/modificaDelegaPersona', { state: { delega : delega , idProfilo : idProfilo, nomeProfilo : nomeProfilo , cognomeProfilo : cognomeProfilo } });
    }

    /*
    useEffect(() => {

        if(idProfilo){
            getDelegheList({idProfilo : idProfilo, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente});
        }

    }, [idProfilo]);

    useEffect(() => {
        if (location.state?.esito) {
            window.scrollTo({top: 0, behavior: 'smooth'});
            const message = location.state.esito.messaggio;
            const type = location.state.esito.esito === "OK" ? 'success' : 'danger';
            setAlert({visible: true, type, message});
            getDelegheList({idProfilo : idProfilo, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente});
        }

    }, [location.state]);


     */

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Prima controlla se hai un `idProfilo`
                if (idProfilo) {
                    // Esegui la chiamata per ottenere le deleghe
                    await getDelegheList({
                        idProfilo: idProfilo,
                        userID: user.userID,
                        cciaa: user.cciaa,
                        gruppoUtente: user.gruppoUtente,
                    });
                }

                // Se esito esiste, gestisci l'alert
                if (location.state?.esito) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });

                    const message = location.state.esito.messaggio;
                    const type = location.state.esito.esito === "OK" ? 'success' : 'danger';
                    setAlert({ visible: true, type, message });
                }
            } catch (error) {
                // Gestione degli errori se qualcosa va storto
                setAlert({ visible: true, type: 'danger', message: 'Errore durante il caricamento dei dati.' });
            }
        };

        fetchData(); // Chiama la funzione appena il componente è montato o quando cambiano le dipendenze
    }, [idProfilo, location.state]);



    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento
        return (
            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">
                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <Spinner active/>
            </Container>
        );
    }


    async function goToDettaglioPersona(profiloId){

        const datiRicerca = {

            dati : {
                "id" : profiloId
            }
        };

        navigate('/private/profiloPersona', { state: { ricerca: datiRicerca , idProfilo : idProfilo , nomeProfilo : nomeProfilo , cognomeProfilo : cognomeProfilo} });

    }



    return(

        <Container className="bg-white py-lg-5 py-lg-6">

            <div className={"pt-4"}>
                <h2>Deleghe di : {nomeProfilo} {cognomeProfilo}</h2>
            </div>

            <Row className="py-lg-5 py-lg-6">

                <Col md={3} >
                    <div className={"sticky-md-top"} style={{...styles.card, zIndex:1, backgroundColor: "#f8f9fa"}}>
                        <Button size="sm" style={styles.sidebarButton} className={"btn btn-outline-primary"}
                                onClick={() => goToDettaglioPersona(idProfilo)}>
                            Ritorna al dettaglio
                        </Button>
                        <Button size="sm" style={styles.sidebarButton} className={"btn btn-outline-primary"}
                                onClick={() => goToInserimentoDelega()}>
                            Aggiungi Delega
                        </Button>
                    </div>
                </Col>
                <Col md={9}>

                    {alert.visible && (
                        <Alert color={alert.type} isOpen={alert.visible}
                               toggle={() => setAlert({...alert, visible: false})}>
                            {alert.message}
                        </Alert>
                    )}

                    <div style={styles.tableContainer}>

                        <Table hover className="border-0">
                            <thead>
                            <tr>
                                <th scope="col" className="text-center" style={{display: "none"}}>#</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Data inizio</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Data fine</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Descrizione</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Modifica</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Elimina</th>
                            </tr>
                            </thead>
                            <tbody className="bg-white">
                            {deleghe.length > 0 ? (
                                deleghe.map((delega, index) => (
                                    <tr key={index}>
                                        <td scope="row" className="text-center"
                                            style={{display: "none"}}>{offset + index + 1}</td>
                                        <td className="text-center" style={styles.tableRowText}>{delega.dataInizio}</td>
                                        <td className="text-center"
                                            style={styles.tableRowText}>{delega.dataFine !== "null" ? delega.dataFine : '-'}</td>
                                        <td className="text-center"
                                            style={styles.tableRowText}>{delega.descrizione}</td>
                                        <td className={"action-icon text-center"} style={styles.actionButton}
                                            style={styles.tableRowText}><Icon icon="it-pencil" color="primary"
                                                                              onClick={() => goToEditDelega(delega)}/>
                                        </td>
                                        <td className={"action-icon text-center"} style={styles.actionButton}
                                            style={styles.tableRowText}><Icon icon="it-delete" color="danger"
                                                                              onClick={() => openDeleteConfirm(delega)}/>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td className="text-center" style={styles.tableRowText} colSpan="8">
                                        Nessun risultato trovato
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>

                    </div>

                </Col>
            </Row>

            <Modal isOpen={showConfirmModal} toggle={closeDeleteConfirm} centered>
                <div toggle={closeDeleteConfirm}>Conferma Eliminazione.</div>
                <div>
                    Sei sicuro di voler rimuovere la delega?
                    <br/>
                    L'azione non potrà essere annullata.
                </div>
                <div>
                    <Button color="secondary" outline onClick={closeDeleteConfirm}>Annulla</Button>
                    &nbsp;
                    <Button color="danger" onClick={confirmDelete}>Conferma ed Elimina</Button>
                </div>
            </Modal>


        </Container>
    );


}
export default GestioneDeleghePersona;
